import { Component, OnInit } from '@angular/core';
import {
  BackendService,
  FieldStructure,
  ListService,
  NotificationService,
  TableActionEnum,
  TableSettings,
} from 'beyond-util';
import { NgxSpinnerService } from 'ngx-spinner';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import { EnumService } from '../../../services/enum.service';
import { ReportService } from '../../../services/report.service';
import { UtilServiceClient } from '../../../services/util.service';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import * as moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import { MimeFileType } from '../../../enums/mime-file-type.enum';

@Component({
  selector: 'app-izvestaj-prihoda-po-emisijama',
  templateUrl: './izvestaj-prihoda-po-emisijama.component.html',
  styleUrls: ['./izvestaj-prihoda-po-emisijama.component.scss'],
})
export class IzvestajPrihodaPoEmisijamaComponent extends IzvestajBaseComponent
  implements OnInit {
  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService,
    protected izvestajSettings: IzvestajSettings,
    private enumService: EnumService
  ) {
    super(_backendService);
    this.orderList = [];
    this.name = 'Izveštaj prihoda po emisijama';
  }

  report: any = {};
  canGenerate = false;

  ngOnInit() {
    this.enumService.fetchValute();
    this.getSettings();
    super.ngOnInit();
    this.refresh();
  }

  refresh() {
    this.report = {
      DatumOd: moment(),
      DatumDo: moment(),
      Emisija: null,
    };

    this.orderList = [];
    this.documentListSource.next(this.orderList);
    this.canGenerate = false;
  }

  valueChanged(event: any) {
    if (event.newValue) {
      this.canGenerate = false;
      this.report[event.fieldMap.fieldKey] = event.newValue;
    }
  }

  getRequestObject() {
    return {
      DatumOd: moment(this.report.DatumOd).format(DEFAULT_DATE_FORMAT),
      DatumDo: moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT),
      Emisija: this.report.Emisija,
    };
  }

  getSettings() {
    this._spinner.show();
    const req = this.reportService.getSettingsPayload(
      ReportNameEnum.PrihodPoEmisijama,
      EndpointTypeEnum.Settings,
      FormCode.MSIZV_PPE
    );

    this.reportService.getSettings(req).subscribe(s => {
      this.splitDetails(s);
      this.fieldStructure = new FieldStructure(s, 'header');
      this.fieldStructure.fieldList.find(
        f => f.fieldKey === 'Emisija'
      ).mandatory = false;
      this.settingsTable = new TableSettings(s.details[0], 'table');
      this.settingsTableSource.next(this.settingsTable);
      this._spinner.hide();
    });
  }

  getFilterString(): string {
    let url = '';
    if (this.report.DatumOd) {
      url +=
        '?datumOd=' + moment(this.report.DatumOd).format(DEFAULT_DATE_FORMAT);
    }

    if (this.report.DatumDo) {
      url +=
        '&datumDo=' + moment(this.report.DatumDo).format(DEFAULT_DATE_FORMAT);
    }

    if (this.report.Emisija) {
      url += '&emisijaId=' + this.report.Emisija.Id;
    }

    return url;
  }

  tableAction(event) {
    if (event.action === TableActionEnum.Filter) {
      this.setRbr();
    }
  }

  setRbr() {
    this.orderList.forEach((e, index) => {
      e['Rbr'] = index + 1;
    });
  }

  filter() {
    this._spinner.show();

    if (!this.report.DatumOd || !this.report.DatumDo) {
      return this.notificationService.notyError(
        'Filteri Datum od i Datum do su obavezni.'
      );
    }

    if (this.report.DatumOd > this.report.DatumDo) {
      return this.notificationService.notyError(
        'Datum do ne sme biti manji od Datum od.'
      );
    }

    const payload = this.reportService.getPayload(
      this.getFilterString(),
      null,
      FormCode.MSIZV_PPE,
      ReportNameEnum.PrihodPoEmisijama,
      EndpointTypeEnum.Form
    );

    this.reportService.getFormData(payload).subscribe(data => {
      if (data.Errors && data.Errors.length) {
        this.canGenerate = false;
        this.notificationService.notyError(data.Errors[0].ErrorMessage);
        this.orderList = [];
        this._spinner.hide();

        return;
      }

      this.canGenerate = true;
      this.orderList = data.ServiceData;
      this.documentListSource.next(this.orderList);
      this._spinner.hide();

      if (this.orderList.length < 1) {
        this.canGenerate = false;
        this.notificationService.notifyError(
          'Ne postoji ni jedna rezervacija za zadate filtere.'
        );

        return;
      }
    });
  }

  onToolbarActionExport() {
    this._spinner.show();

    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSIZV_PPE,
      ReportNameEnum.PrihodPoEmisijama,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(request).subscribe(data => {
      const formattedDate: string = `${moment(new Date()).format(
        'YYYY-MM-DD_HH:mm'
      )}`.replace(
        `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
        '-'
      );
      this._spinner.hide();

      ReportService.downloadBlob(
        data,
        MimeFileType.Xlsx,
        `Osnovni_izveštaj_realizacije_${formattedDate}`
      );
    });
  }

  onToolbarActionPrint() {
    this._spinner.show();
    if (!this.orderList.length || this.canGenerate === false) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const report = {
      Header: this.getRequestObject(),
      Table: this.orderList,
    };

    const request = this.reportService.getPayload(
      null,
      report,
      FormCode.MSIZV_PPE,
      ReportNameEnum.PrihodPoEmisijama,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(request).subscribe(data => {
      const formattedDate: string = `${moment(new Date()).format(
        'YYYY-MM-DD_HH:mm'
      )}`.replace(
        `${moment(new Date()).format('YYYY-MM-DD_HH:mm')}`.charAt(13),
        '-'
      );
      this._spinner.hide();

      ReportService.openBlob(data, MimeFileType.Pdf);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-prihoda-po-emisijama/izvestaj-prihoda-po-emisijama.component.ts